import { Input } from 'antd'
import { createChildTablePrintComponent } from 'factories/ChildTablePrint'

const createCountTableCellComponent = (field) => (self, item) => (
  <Input value={item[field] > -1 ? item[field] : null} readOnly />
)

export default createChildTablePrintComponent({
  tableCellComponents: {
    count: createCountTableCellComponent('count'),
    count2: createCountTableCellComponent('count2'),
  },
  getRowClassName: (self) => (record, index) => (index % 2 === 1 ? 'bg-gray-light' : ''),
})()
